import { render, staticRenderFns } from "./BannerLink.vue?vue&type=template&id=7e229d4c&scoped=true&"
import script from "./BannerLink.vue?vue&type=script&lang=js&"
export * from "./BannerLink.vue?vue&type=script&lang=js&"
import style0 from "./BannerLink.vue?vue&type=style&index=0&id=7e229d4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e229d4c",
  null
  
)

export default component.exports